__webpack_require__.p = "/earthquake-globe/";